import { render, staticRenderFns } from "./gc-comment-icon.vue?vue&type=template&id=4f8ec5a4&scoped=true"
import script from "./gc-comment-icon.vue?vue&type=script&lang=js"
export * from "./gc-comment-icon.vue?vue&type=script&lang=js"
import style0 from "./gc-comment-icon.vue?vue&type=style&index=0&id=4f8ec5a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8ec5a4",
  null
  
)

export default component.exports